import React, { Fragment, useState } from "react";
import * as MUI from "@mui/material";
import GoBack from "../../components/buttons/GoBack";
import PageContentWrapper from "../../components/wrappers/PageContentWrapper";
import { TERMS_INTERNAL } from "../../enums/UrlPaths";
import TermsAndConditionsCro from "../../utils/i18n/localisation/hr/TermsAndConditionsCro";
import i18next from "i18next";
import TermsAndConditionsEng from "../../utils/i18n/localisation/en/TermsAndConditionsEng";
import AuthFooter from "../auth/login/component/AuthFooter";
import TermsAndConditionsDe from "../../utils/i18n/localisation/de/TermsAndConditionsDe";
import TermsAndConditionsSlo from "../../utils/i18n/localisation/sl/TermsAndConditionsSl";
import TermsAndConditionsSrb from "../../utils/i18n/localisation/sr/TermsAndConditionsSr";
export default function TermsAndConditionsPage() {
  const location = window.location.href;
  const [view, setView] = useState();
  function isInternal() {
    return location.includes(TERMS_INTERNAL);
  }

  React.useEffect(() => {
    const getLanguage = () => i18next.language;
    switch (getLanguage()) {
      case "hr":
        setView(<TermsAndConditionsCro />);
        break;
      case "en":
        setView(<TermsAndConditionsEng />);
        break;
      case "de":
        setView(<TermsAndConditionsDe />);
        break;
      case "sl":
        setView(<TermsAndConditionsSlo />);
        break;
      case "sr":
        setView(<TermsAndConditionsSrb />);
        break;
      default:
        setView(<TermsAndConditionsCro />);
    }
  }, [i18next.language]);

  return (
    <Fragment>
      <PageContentWrapper>
        <MUI.Stack spacing={5} sx={{ mb: 30 }}>
          <MUI.Stack
            direction={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
          >
            <GoBack />
          </MUI.Stack>
          {view}
        </MUI.Stack>
      </PageContentWrapper>
      <AuthFooter />
    </Fragment>
  );
}
